import { render, staticRenderFns } from "./LogoGiftery.vue?vue&type=template&id=31111717&scoped=true&"
import script from "./LogoGiftery.vue?vue&type=script&lang=js&"
export * from "./LogoGiftery.vue?vue&type=script&lang=js&"
import style0 from "./LogoGiftery.vue?vue&type=style&index=0&id=31111717&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31111717",
  null
  
)

export default component.exports